module.exports = __webpack_public_path__ + "static/nesci-cd871fee34d4babde754d59a6beace20.jpg";